import { Grid, InputAdornment, TextField, Typography } from '@mui/material';
import RequireIcon from '@mui/icons-material/FiberManualRecord';
import { useStyles } from '../../../styles/NewOrUpdateForm.styles';

import { useState } from 'react';

type RequiredNumber<State extends Record<string, any>> = {
    stateKey: keyof State;
    label: string;
    draft: [State, React.Dispatch<State>];
    validateFn: (text: string) => boolean;
    helperText?: {
        valid: string;
        invalid: string;
    };
    disabled?: boolean;
    size?: number;
    maxLength?: number;
    required?: boolean;
};

export const FormNumberInput = <State extends Record<string, any>>({
    stateKey,
    label,
    draft,
    disabled = false,
    validateFn,
    helperText = {
        valid: '',
        invalid: '',
    },
    size,
    maxLength,
    required = true,
}: RequiredNumber<State>) => {
    const classes = useStyles();
    const [draftState, setDraftState] = draft;
    const [isValid, setIsValid] = useState<boolean>(true);

    return (
        <Grid item md={size ?? 6} xs={12} sm={12} className={classes.textInputWrapper}>
            <Typography variant='body2' color={!isValid ? 'error' : 'text.primary'} fontWeight={1000} sx={{ pl: 0.5 }}>
                {label}
            </Typography>

            <TextField
                inputMode='numeric'
                id={`grid-number-input-${String(stateKey)}`}
                label=''
                size='small'
                variant='outlined'
                className={classes.textInput}
                value={draftState?.[stateKey] || ''}
                onChange={(e) => {
                    const { value } = e.target;
                    if (maxLength && value.length > maxLength) return;

                    setDraftState({
                        ...draftState,
                        [stateKey]: value.replace(/[^0-9.]/g, ''),
                    });

                    setIsValid(validateFn(value));
                }}
                type={'text'}
                error={!isValid}
                helperText={isValid ? helperText.valid : helperText.invalid}
                disabled={disabled}
                required={required}
                InputProps={
                    required
                        ? {
                              endAdornment: (
                                  <InputAdornment position='end'>
                                      <RequireIcon fontSize='inherit' style={{ color: 'red' }} />
                                  </InputAdornment>
                              ),
                          }
                        : undefined
                }
            />
        </Grid>
    );
};
